export const getClient = (involved: any) =>
    involved?.find((bet: any) => bet?.typSnippet?.name === 'Auftraggeber')?.kontakt || {};
